import './index.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';

import { App } from '@/App';
import { IS_MINI_APP, REDIRECTING_TO_MINI, ROUTER_BASENAME } from '@/appMode';
import { applyStoredA11y } from '@/components/AccessibilityWidget';
import { AgeGate } from '@/components/AgeGate';
import { SessionProvider } from '@/hooks/useSession';

// Telegram WebApp API only on /mini - the website ignores it even when opened inside Telegram's browser
const tg = IS_MINI_APP ? window.Telegram?.WebApp : undefined;
tg?.ready();
tg?.expand();
// keep the Mini App open: no swipe-down to close (Bot API 7.7+)
tg?.disableVerticalSwipes?.();
// one dark brand theme everywhere; paint Telegram's own header / background to match
tg?.setHeaderColor?.('#000000');
tg?.setBackgroundColor?.('#000000');
document.documentElement.classList.add('dark');
// saved accessibility options (text size, contrast...) before the first paint
applyStoredA11y();

const root = document.getElementById('root');
if (!root) throw new Error('#root missing');

// inside Telegram on a website path: appMode is already moving to /mini - don't flash the website login
if (!REDIRECTING_TO_MINI)
  createRoot(root).render(
    <StrictMode>
      <AgeGate>
        <BrowserRouter basename={ROUTER_BASENAME}>
          <SessionProvider>
            <App />
          </SessionProvider>
        </BrowserRouter>
      </AgeGate>
    </StrictMode>
  );
